// extracted by mini-css-extract-plugin
module.exports = {"subscription-link":"styles-m__subscription-link__3PHfU","text":"styles-m__text__3h8iN","arrow-right":"styles-m__arrow-right__2z_R_"};